import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { LearnRoutingModule } from './learn-routing.module';

import { SharedModule } from '../../shared.module';

import { LearnComponent } from './learn.component';

// Pages Overview
import { LearnOverviewComponent } from './overview/overview.component';

// Widgets Overview
import { WidgetNextEventComponent } from './overview/widgets/next-event/next-event.component';
import { WidgetContentComponent } from './overview/widgets/content/content.component';
import { WidgetContactComponent } from './overview/widgets/contact/contact.component';
import { WidgetStatisticsComponent } from './overview/widgets/statistics/statistics.component';
import { WidgetResourceComponent } from './overview/widgets/resource/resource.component';
import { WidgetGrikySkillsComponent } from './overview/widgets/griky-skills/griky-skills.component';

// Pages Onboarding
import { LearnOnboardingComponent } from './onboarding/onboarding.component';

// Pages Contents
import { LearnContentComponent} from './content/content.component';
import { LearnContentListComponent } from './content/list/list.component';
import { LearnContentSavedComponent } from './content/saved/saved.component';

// Pages Catalogue
import { LearnCatalogueComponent } from './catalogue/catalogue.component';
import { LearnCatalogueSliderComponent } from './catalogue/slider/slider.component';
import { LearnCatalogueListComponent } from './catalogue/list/list.component';
import { LearnCatalogueWatchComponent } from './catalogue/watch/watch.component';
import { LearnCatalogueWatchExploreComponent } from './catalogue/watch/details/explore/explore.component';
import { LearnCatalogueWatchThematicComponent } from './catalogue/watch/details/thematic/thematic.component';
import { LearnCatalogueWatchLevelComponent } from './catalogue/watch/details/level/level.component';

// Pages Community
import { LearnCommunityComponent } from './community/community.component';
import { LearnCommunityListComponent } from './community/list/list.component';
import { LearnCommunityWatchComponent } from './community/watch/watch.component';
import { LearnCommunityModalSubscribeComponent } from './community/list/modal/modal-subscribe.component';

// Pages Details
import { LearnDetailComponent } from './detail/detail.component';
import { LearnDetailInstanceComponent } from './detail/instance/instance.component';
import { LearnDetailInstanceCorrectionComponent } from './detail/instance/correction/correction.component';
import { LearnDetailInstanceSummaryComponent } from './detail/instance/summary/summary.component';
import { LearnDetailInstancePresentationComponent } from './detail/instance/presentation/presentation.component';
import { LearnDetailExternalContentResultComponent } from './detail/external-content/result/result.component';
import { LearnDetailInstanceDiscussionComponent } from './detail/instance/discussion/discussion.component';
import { LearnDetailJourneyComponent } from './detail/journey/journey.component';
import { LearnDetailJourneyCorrectionComponent } from './detail/journey/correction/correction.component';
import { LearnDetailJourneySummaryComponent } from './detail/journey/summary/summary.component';
import { LearnDetailJourneyPresentationComponent } from './detail/journey/presentation/presentation.component';
import { LearnDetailJourneyDiscussionComponent } from './detail/journey/discussion/discussion.component';
import { LearnDetailTemplateComponent } from './detail/template/template.component';
import { LearnDetailTemplateSummaryComponent } from './detail/template/summary/summary.component';
import { LearnDetailTemplatePresentationComponent } from './detail/template/presentation/presentation.component';
import { LearnDetailExternalContentComponent } from './detail/external-content/external-content.component';
import { LearnDetailExternalContentPresentationComponent } from './detail/external-content/presentation/presentation.component';
import { LearnIntegrationComponent } from './integration/integration.component';
import { AppCommon2Module } from '@common2/common.module';
import { AppCommonModule } from '../../common/common.module';
import { PresentationAdditionalDetails } from './detail/components/additional-details/additional-details.component';
import { LearnBoclips } from './boclip/boclip.component';
import { OnementorComponent } from './content/onementor/onementor.component';
import { AcademyComponent } from './academy/academy.component';
import { BannerComponent } from './overview-new/banner/banner.component';
import { CarouselComponent } from './overview-new/carousel/carousel.component';
import { CourseSliderComponent } from './overview-new/course-slider/course-slider.component';
import { ExtrasComponent } from './overview-new/extras/extras.component';
import { RecentCoursesComponent } from './overview-new/recent-courses/recent-courses.component';
import { LearnOverviewNewComponent } from './overview-new/overview-new.component';
import { AcademyCalendarComponent } from './academy/academy-calendar/academy-calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AcademyPageComponent } from './academy/academy-page/academy-page.component';
import { AcademyPublicPageComponent } from './academy/academy-public-page/academy-public-page.component';
import { AcademyBadgesComponent } from './academy/academy-badges/academy-badges.component';
import { AcademyCertificatesComponent } from './academy/academy-certificates/academy-certificates.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CoursesStatsCardComponent } from '@components/courses-stats-card/courses-stats-card.component';
import { SkillsCompetenciesComponent } from '@components/skills-competencies/skills-competencies.component';



@NgModule({
    declarations: [
        LearnComponent,
        LearnOverviewNewComponent,
        LearnOverviewComponent,
        LearnIntegrationComponent,
        WidgetNextEventComponent,
        WidgetContentComponent,
        WidgetContactComponent,
        WidgetStatisticsComponent,
        WidgetResourceComponent,
        WidgetGrikySkillsComponent,
        LearnOnboardingComponent,
        LearnContentComponent,
        LearnContentListComponent,
        LearnContentSavedComponent,
        LearnCatalogueComponent,
        LearnCatalogueSliderComponent,
        LearnCatalogueListComponent,
        LearnCatalogueWatchComponent,
        LearnCatalogueWatchExploreComponent,
        LearnCatalogueWatchThematicComponent,
        LearnCatalogueWatchLevelComponent,
        LearnCommunityComponent,
        LearnCommunityListComponent,
        LearnCommunityWatchComponent,
        LearnCommunityModalSubscribeComponent,
        LearnDetailComponent,
        LearnDetailInstanceComponent,
        LearnDetailInstanceCorrectionComponent,
        LearnDetailInstanceSummaryComponent,
        LearnDetailInstancePresentationComponent,
        LearnDetailExternalContentResultComponent,
        LearnDetailInstanceDiscussionComponent,
        LearnDetailJourneyComponent,
        LearnDetailJourneyCorrectionComponent,
        LearnDetailJourneySummaryComponent,
        LearnDetailJourneyPresentationComponent,
        LearnDetailJourneyDiscussionComponent,
        LearnDetailTemplateComponent,
        LearnDetailTemplatePresentationComponent,
        LearnDetailTemplateSummaryComponent,
        LearnDetailExternalContentComponent,
        LearnDetailExternalContentPresentationComponent,
        PresentationAdditionalDetails,
        LearnBoclips,
        OnementorComponent,
        AcademyComponent,
        BannerComponent,
        CarouselComponent,
        CourseSliderComponent,
        ExtrasComponent,
        RecentCoursesComponent,
        AcademyCalendarComponent,
        LeaderboardComponent,
        AcademyPageComponent,
        AcademyPublicPageComponent,
        AcademyBadgesComponent,
        AcademyCertificatesComponent,
        CoursesStatsCardComponent,
        SkillsCompetenciesComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        SharedModule,
        LearnRoutingModule,
        AppCommon2Module,
        AppCommonModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
          }),
        CarouselModule,
        PdfViewerModule
    ],
    exports: [
        SkillsCompetenciesComponent
    ]
})
export class LearnModule {}
